import {
  IconBookmark,
  IconBookmarkFilled,
  IconHeart,
  IconHeartFilled,
  IconPin,
  IconPinFilled,
  IconStar,
  IconStarFilled,
} from '@tock/icons';
import { PlaylistType } from 'utils/profileUtils';
import { Theme, css } from '@emotion/react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

interface GetPlaylistIconProps {
  playlistType: PlaylistType | undefined;
  filled?: boolean;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  starIcon: {
    color: theme.legacyColors.legacyDecorative12,
  },
  starIconFilled: {
    color: theme.legacyColors.legacyDecorative05,
  },
  heartIcon: {
    color: theme.legacyColors.legacyDecorative11,
  },
  wantToGoIcon: {
    color: theme.legacyColors.legacyDecorative15,
  },
}));

const PlaylistTypeIcon: React.FunctionComponent<GetPlaylistIconProps> = ({
  playlistType,
  filled,
  className,
}) => {
  const styles = useStyles();
  const getIcon = () => {
    switch (playlistType) {
      case 'WANT_TO_GO':
        return filled ? (
          <IconBookmarkFilled className={clsx(styles.wantToGoIcon, className)} />
        ) : (
          <IconBookmark
            css={(theme: Theme) => css`
              color: ${theme.legacyColors.legacyDecorative15};
            `}
            className={clsx(styles.wantToGoIcon, className)}
          />
        );
      case 'CUSTOM':
        return filled ? (
          <IconPinFilled className={clsx(className)} />
        ) : (
          <IconPin className={clsx(className)} />
        );
      case 'FAVORITE':
        return filled ? (
          <IconHeartFilled className={clsx(styles.heartIcon, className)} />
        ) : (
          <IconHeart
            css={(theme: Theme) => css`
              color: ${theme.legacyColors.legacyDecorative11};
            `}
            className={className}
          />
        );
      case 'STAR':
      default:
        return filled ? (
          <IconStarFilled
            css={(theme: Theme) => css`
              color: ${theme.legacyColors.legacyDecorative05};
            `}
            className={className}
          />
        ) : (
          <IconStar
            css={(theme: Theme) => css`
              color: ${theme.legacyColors.legacyDecorative12};
            `}
            className={className}
          />
        );
    }
  };
  return <>{getIcon()}</>;
};

export default PlaylistTypeIcon;
